import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import DisabledButtonWithTooltip from '@atlassian/jira-disabled-button-with-tooltip/src/index.tsx';

const backgroundColorSelected = token('color.background.selected');
const backgroundColor = token('elevation.surface.raised');
const borderColor = token('color.border');
const boxShadowColor = `1px 0px ${token('elevation.shadow.raised')}`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardBaseStyle = styled.a<{ isSelected?: boolean; visualRefresh: boolean }>(
	{
		display: 'block',
		// eslint-disable-next-line @atlaskit/platform/expand-spacing-shorthand
		padding: token('space.100'),
		boxSizing: 'border-box',
		'&:hover': {
			textDecoration: 'none',
		},
		'&:focus': {
			boxShadow: `${token('color.border.focused')} 0 0 0 2px inset`,
			textDecoration: 'none',
			outline: 'none',
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	({ visualRefresh, isSelected }) =>
		visualRefresh
			? {
					boxShadow: token('elevation.shadow.raised'),
					backgroundColor: isSelected
						? token('color.background.accent.blue.subtlest')
						: token('elevation.surface.raised'),
					borderRadius: token('radius.small'),
					margin: token('space.025'), // small margin needed so box shadow is visible.
					padding: token('space.150'),
				}
			: {
					backgroundColor: isSelected ? backgroundColorSelected : backgroundColor,
					borderTop: 0,
					borderBottom: `${token('border.width')} solid ${borderColor}`,
					borderLeft: `${token('border.width')} solid ${borderColor}`,

					'&:first-of-type': {
						borderTop: `${token('border.width')} solid ${borderColor}`,
						borderRadius: `${token('radius.small')} ${token('radius.small')} 0 0`,
					},

					'&:last-child': {
						boxShadow: `1px 1px ${boxShadowColor}`,
						borderRadius: `0 0 ${token('radius.small')} ${token('radius.small')}`,
					},

					'&:first-of-type:last-child': {
						borderRadius: `${token('radius.small')}`,
					},
				},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FullHeightDisabledButton = styled(DisabledButtonWithTooltip)({
	height: '100%',
});
